import React from 'react'
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AiOutlineHome } from 'react-icons/ai';
import useUser from "../../hooks/useUser";

const NoService = () => {
  const [dataUser, setDataUser] = useUser();
  const handleReload = ()=>{
    setDataUser({
      ...dataUser,
      pageReload: false,
      errorAptos: undefined
    })
  }
  return (
    <div>
      <h2 className='text-danger fs-6 text-center pb-3 pt-3'>Error en el servicio favor de reintentar mas tarde...</h2>
      <Container className='w-100 d-flex justify-content-end mb-3'>
      <Link to='/' onClick={handleReload} className='btn btn-secondary fs-5 mt-3'>{<AiOutlineHome/>||'Home'}</Link>
      </Container>
    </div>
  )
}

export default NoService